export enum AuthMethod {
  UsernamePassword,
  ServiceProviderAuth,
  ApplicationUser,
}
export enum DataCenter {
  US = 1,
  EU = 2,
  AU = 3,
  CA = 4,
  Dev = 101,
  QA = 102,
  PreProd = 103,
}

export interface ApiSsoState {
  isNewAccount: boolean;
  accountKey: string;
  redirectUrl: string;
}
export enum CrmConnectionType {
  UsernamePassword = 0,
  SSO = 1,
  OauthV2 = 2,
}
export enum CrmAuthenticationType {
  ADFS = 1,
  PASSPORT = 1,
  OnlineFederation = 3,
}
export interface InterfaceSettingsApiResponse {
  options?: AnalyticsOptions;
  accountKey?: string | null;
  azureActiveDirectoryTenantId: string | null;
  azureActiveDirectoryApplicationId: string | null;
  azureActiveDirectoryApplicationKey: string | null;
  azureAdClientId: string;
  azureKeyVaultCertificateIdentifier: string | null;
  azureActiveDirectoryRefreshToken: string | null;
  contactEmail: string | null;
  crmAccountName: string | null;
  crmAuthenticationType: CrmAuthenticationType;
  crmConnectionType: CrmConnectionType;
  crmLocationsXml?: string | null;
  crmUserDomain?: string | null;
  crmLocationUrl: string;
  crmConnectionComputedType: CrmConnectionComputedType;
  crmUserName?: string | null;
  crmUserPassword?: string | null;
  hasAzureActiveDirectoryRefreshToken?: boolean;
  hasAzureActiveDirectoryApplicationKey: boolean;
  hasCrmUserPassword?: boolean;
  isRelay?: boolean;
}
export interface AnalyticsOptions {
  email: string;
  region: DataCenter;
  version: CrmVersion;
}
export enum CrmVersion {
  MS_CRM_2013 = 5,
  MS_CRM_2013_ONLINE_FED = 6,
  MS_CRM_2015 = 7,
  MS_CRM_2015_ONLINE_FED = 8,
  MS_CRM_2016 = 9,
  MS_CRM_2016_ONLINE_FED = 10,
  D365_8_2_X_8_3_X_ONLINE_FED = 11,
  D365_8_2_X_8_3_X = 12,
  D365_9_0_X = 13,
  D365_9_0_X_ONLINE_FED = 14,
  D365_9_1_OR_HIGHER = 15,
  D365_9_1_X_ONLINE_FED = 16,
}
export enum CrmConnectionComputedType {
  OnPremise = 0,
  Online = 1,
  OnlineOAuth = 2,
  OnlineOffice365 = 3,
  ServiceBus = 4,
  SsoUserImpersonationUsingRefreshToken = 5,
  SsoApplicationUser = 6,
  SsoApplicationUserCertificate = 7,
}
export enum AppUserType {
  Secret,
  Certificate,
}
